// extracted by mini-css-extract-plugin
export default {"cartLink":"CartLink_cartLink__lxJFt","cartLinkFixedActionBar":"CartLink_cartLinkFixedActionBar__x9Lgu","cartIcon":"CartLink_cartIcon__b7W5x","cartBadge":"CartLink_cartBadge__0NNqY"};